<script setup lang="ts">
import { computed, type CSSProperties } from 'vue';
import { useParentId } from '@/hooks/useParentId';
import { PRIMARY_COLOR } from '@dts/shared/src/config/color';
import TBase from './TBase.vue';
import type { TypographyLinkProps } from './types';

defineOptions({
  name: 'CustomLink',
});

const props = withDefaults(defineProps<TypographyLinkProps>(), {
  fontFamily: 'BMWTypeNext',
  size: 24,
  color: PRIMARY_COLOR,
  href: '',
  target: '_blank',
  weight: 300,
  underline: true,
  clickFunc: undefined,
});

const { pid } = useParentId();

const linkStyle = computed<CSSProperties>(() => ({
  textDecoration: props.underline ? 'underline' : undefined,
  color: props.color,
  cursor: 'pointer',
}));

const handleClick = (event: MouseEvent) => {
  if (props.clickFunc) {
    return props.clickFunc(event);
  }
  if (props.href) {
    window.open(`${props.href}?${pid.value}`, props.target);
  }
};
</script>

<template>
  <TBase
    class="link"
    :style="linkStyle"
    :font-family="props.fontFamily"
    :size="props.size"
    :color="props.color"
    :weight="props.weight"
    :on-click="handleClick"
  >
    <slot />
  </TBase>
</template>

<style scoped lang="scss">
.link {
  user-select: none;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }

  &:active {
    opacity: 1;
  }
}
</style>
